var map = {
	"./forest-mobile.mp4": "dNdw",
	"./ocean-mobile.mp4": "Qoyf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y3+f";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-mobile\.mp4$
// module id = Y3+f
// module chunks = 1